import React from 'react';
import { Modal, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import SignatureCapture from './SignatureCapture';

const SignatureModal = ({ open, onClose, onSave, loading }) => {
  const { t } = useTranslation();

  const handleSave = (signatureData) => {
    onSave(signatureData);
  };

  return (
    <Modal
      title={t('patient_documents.signature.title')}
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
      centered
      data-testid="signature-modal"
    >
      <div data-testid="spin-container" className={loading ? 'ant-spin-spinning' : ''}>
        <Spin spinning={loading}>
          <SignatureCapture
            onSave={handleSave}
            onCancel={onClose}
            disabled={loading}
            data-testid="signature-canvas"
          />
        </Spin>
      </div>
    </Modal>
  );
};

export default SignatureModal; 